module.exports = __webpack_public_path__ + "img/OMillionaire_logo_Final.627c2289.svg";